import React from 'react'
import {
  FileSizeIndicator,
  ProgressBar,
  useAudioPlayer,
  useMessageContext,
  useStateStore,
} from 'stream-chat-react'
import MessagingDownloadIcon from './messaging-download-icon'
import MessagingPlayButton from './messaging-play-button'
import { sanitizeAttachmentUrl } from './messaging-utils'

const audioPlayerStateSelector = state => ({
  isPlaying: state.isPlaying,
  progress: state.progressPercent,
})

const AudioAttachmentUI = ({ audioPlayer, downloadUrl }) => {
  const { isPlaying, progress } =
    useStateStore(audioPlayer?.state, audioPlayerStateSelector) ?? {}

  return (
    <div
      className="str-chat__message-attachment-audio-widget"
      data-testid="audio-widget"
    >
      <div className="str-chat__message-attachment-audio-widget--play-controls">
        <MessagingPlayButton
          isPlaying={!!isPlaying}
          onClick={audioPlayer.togglePlay}
        />
      </div>
      <div className="str-chat__message-attachment-audio-widget--text">
        <div className="str-chat__message-attachment-audio-widget--text-first-row">
          <div className="str-chat__message-attachment-audio-widget--title">
            {audioPlayer.title}
          </div>
          {downloadUrl && (
            <a
              className="str-chat__message-attachment-file--item-download"
              download
              href={downloadUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              <MessagingDownloadIcon className="str-chat__message-attachment-download-icon" />
            </a>
          )}
        </div>
        <div className="str-chat__message-attachment-audio-widget--text-second-row">
          <FileSizeIndicator fileSize={audioPlayer.fileSize} />
          <ProgressBar onClick={audioPlayer.seek} progress={progress ?? 0} />
        </div>
      </div>
    </div>
  )
}

const MessagingAudio = props => {
  const {
    og: {
      asset_url: assetUrl,
      file_size: fileSize,
      mime_type: mimeType,
      title,
      waveform_data: waveformData,
    },
  } = props
  const { message, threadList } = useMessageContext() ?? {}
  const safeAssetUrl = sanitizeAttachmentUrl(assetUrl)

  const audioPlayer = useAudioPlayer({
    fileSize,
    mimeType,
    requester:
      message?.id &&
      `${threadList ? message.parent_id ?? message.id : ''}${message.id}`,
    src: safeAssetUrl,
    title,
    waveformData,
  })

  return audioPlayer ? (
    <AudioAttachmentUI audioPlayer={audioPlayer} downloadUrl={safeAssetUrl} />
  ) : null
}

export default React.memo(MessagingAudio)
